import axios from 'axios';
import { get, API_URL } from '../utils/api';

// Configure API URL from environment or use default
// const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

/**
 * Get a list of all active sites (public endpoint)
 * Use this for the registration page
 * @returns {Promise<Array>} List of active sites with uuid, siteId, and name
 */
export const getPublicSites = async () => {
  try {
    const response = await get(`${API_URL}/site/public/sites`);
    return response.data;
  } catch (error) {
    // console.error('Error fetching public sites:', error.response?.data || error.message);
    throw error;
  }
};

/**
 * Get a list of all active units for a specific site (public endpoint)
 * Use this for the registration page
 * @param {string} siteUuid - UUID of the site to get units for
 * @returns {Promise<Array>} List of active units with unitNumber, unitId, and displayName
 */
export const getPublicUnits = async (siteUuid) => {
  try {
    if (!siteUuid) {
      throw new Error('Site UUID is required');
    }
    
    const response = await get(`${API_URL}/site/public/units`, { siteUuid });
    
    return response.data;
  } catch (error) {
    // console.error('Error fetching public units:', error.response?.data || error.message);
    throw error;
  }
};

/**
 * Get a list of all active sites
 * @returns {Promise<Array>} List of active sites with uuid, siteId, and name
 */
export const getActiveSites = async () => {
  try {
    const response = await get(`${API_URL}/site/sites/list`);
    return response.data;
  } catch (error) {
    // console.error('Error fetching sites:', error.response?.data || error.message);
    throw error;
  }
};

/**
 * Get a list of all active units for a specific site
 * @param {string} siteUuid - UUID of the site to get units for
 * @returns {Promise<Array>} List of active units with unitNumber, unitId, and displayName
 */
export const getActiveUnits = async (siteUuid) => {
  try {
    if (!siteUuid) {
      throw new Error('Site UUID is required');
    }
    
    const response = await get(`${API_URL}/site/units/list`, { siteUuid });
    
    return response.data;
  } catch (error) {
    // console.error('Error fetching units:', error.response?.data || error.message);
    throw error;
  }
}; 